import { useAuthStore } from '../../../stores/authStore';
import { useSettings } from '../../../hooks/useSettings';
import { LanguageSection } from '../../../components/settings/LanguageSection';
import { Toast } from '../../../components/common/Toast';
import { SettingsSubPage } from '../components/SettingsSubPage';
import { Skeleton } from '../../../components/common/Skeleton';
import { palette, admin } from '../../../styles/tokens';

export function LanguagePage() {
  const authBusiness = useAuthStore(s => s.business);
  const { business, loading, error, saved, updateBusiness } = useSettings(authBusiness?.id);

  if (loading || (!business && !error)) {
    return (
      <SettingsSubPage title="Language" description="App language, client language, auto-translate">
        <div style={{ background: palette.white, borderRadius: admin.cardRadius, border: `1px solid ${admin.border}`, padding: 20 }}>
          <Skeleton width={140} height={14} style={{ marginBottom: 12 }} />
          <Skeleton width={240} height={32} radius={6} style={{ marginBottom: 16 }} />
          <Skeleton width={140} height={14} style={{ marginBottom: 12 }} />
          <Skeleton width={240} height={32} radius={6} />
        </div>
      </SettingsSubPage>
    );
  }

  if (error || !business) {
    return (
      <SettingsSubPage title="Language" description="App language, client language, auto-translate">
        <div style={{ padding: 40, textAlign: 'center', color: palette.red, fontSize: 13.5 }}>{error ?? 'Not found'}</div>
      </SettingsSubPage>
    );
  }

  return (
    <SettingsSubPage title="Language" description="App language, client language, auto-translate">
      <Toast message="Language saved." type="success" isVisible={saved} onDismiss={() => {}} />
      <LanguageSection business={business} onSave={updateBusiness} />
    </SettingsSubPage>
  );
}
